import apiClient from "../api/apiClient";
import { Notify } from "../../helpers/notification";

// ---- Reads ----

export const GetAllTicket = (page = 1, pageSize = 20) => () =>
  apiClient
    .get(`/maintenance/tickets`, { params: { page, pageSize } })
    .then((r) => r.data.data);

export const GetRecentTickets = (limit = 5) => () =>
  apiClient
    .get(`/maintenance/tickets/recent`, { params: { limit } })
    .then((r) => r.data.data);

export const GetTicket = (id) => () =>
  apiClient.get(`/maintenance/tickets/${id}`).then((r) => r.data.data);

export const GetTicketPublic = (id) => () =>
  apiClient
    .get(`/public/maintenance/tickets/${id}`)
    .then((r) => r.data.data);

export const GetTicketPublicByZzID = (zzId) => () =>
  apiClient
    .get(`/public/maintenance/tickets/by-zzid/${zzId}`)
    .then((r) => r.data.data);

export const VerifyTicketPublic = (zzId, verifiedBy) => () =>
  apiClient
    .post(`/public/maintenance/tickets/by-zzid/${zzId}/verify`, { verifiedBy })
    .then((r) => r.data.data);

export const ReopenTicketPublic = (zzId, reopenedBy) => () =>
  apiClient
    .post(`/public/maintenance/tickets/by-zzid/${zzId}/reopen`, { reopenedBy })
    .then((r) => r.data.data);

export const AddNotePublic = (zzId, text, actor) => () =>
  apiClient
    .post(`/public/maintenance/tickets/by-zzid/${zzId}/notes`, { text, actor })
    .then((r) => r.data.data);

export const GetMaintenanceTypes = () => () =>
  apiClient.get(`/maintenance/types`).then((r) => r.data.data);

// Categories/sub-categories/locations managed in FileMaker (MCAT/MCTS/MCWR tables)
export const GetMaintenanceCategories = () => () =>
  apiClient.get(`/maintenance/categories`).then((r) => r.data.data);

// ---- Writes ----

export const AddTicket = (payload) => () =>
  apiClient
    .post(`/maintenance/tickets`, payload)
    .then((r) => r.data.data);

export const EditTicket = (id, payload) => () =>
  apiClient
    .patch(`/maintenance/tickets/${id}`, payload)
    .then((r) => r.data.data);

export const AddNote = (ticketId, notes) => () =>
  apiClient
    .post(`/maintenance/tickets/${ticketId}/notes`, { notes })
    .then((r) => r.data.data);

// ---- Uploads ----
// Returns { url, key, contentType, size }. Frontend calls this per-file before
// hitting AddTicket / EditTicket with the resulting URLs embedded in `notes`.
export const UploadFile = ({ file, filename, modulePrefix = "NOTE" }) => () => {
  const form = new FormData();
  form.append("file", file);
  form.append("filename", filename);
  form.append("modulePrefix", modulePrefix);
  return apiClient
    .post(`/upload`, form, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data.data);
};

// ---- Legacy constants (reducer + unmigrated pages still reference these) ----

export const TICKET_DETAILS = "TICKET_DETAILS";
export const GET_SURVEY = "GET_SURVEY";
export const ALL_TICKET = "ALL_TICKET";
export const MAINTAINANCE_TICKET_DATA = "MAINTAINANCE_TICKET_DATA";

export const GetMaintainanceTicketData = (payload, cb) => (dispatch) => {
  apiClient
    .get(`/maintenance/chart`, {
      params: { startDate: payload.startDate, endDate: payload.endDate },
    })
    .then((response) => {
      cb && cb(response.data.data);
      dispatch({ type: MAINTAINANCE_TICKET_DATA, payload: response.data.data });
    })
    .catch((err) => {
      console.log(err);
      cb && cb(false);
    });
};

export const GetSurvey = (id, cb) => (dispatch) => {
  apiClient
    .get(`/public/surveys/questions`)
    .then((response) => {
      cb && cb(true);
      dispatch({ type: GET_SURVEY, payload: response.data.data });
    })
    .catch(() => {
      cb && cb(false);
      Notify("danger", "Something Bad Happened :(");
    });
};

export const addSurveyAction = (payload, cb) => (dispatch) => {
  apiClient
    .post(`/public/surveys`, payload)
    .then(() => { cb && cb(); })
    .catch((error) => {
      Notify("danger", "Something Bad Happened :(");
      console.log(error);
      cb && cb();
    });
};

export const CheckSurveyEligibility = ({ email, peopleZzId }) => () => {
  const params = {};
  if (email) params.email = email;
  if (peopleZzId) params.peopleZzId = peopleZzId;
  return apiClient
    .get(`/public/surveys/eligibility`, { params })
    .then((r) => r.data.data);
};
